import React from "react";
import MiniDrawer from "./Drawer/Menu/Menu";
import AppRoutes from "./Drawer/Routes";
import { Box } from "@mui/material";
import MainLayout from "./Pages/Main";
import { BASENAME } from "./config";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import LoginProvider from "./Pages/Login/LoginProvider";
import ForgotPasswordPage from "./Pages/Login/ForgotPasswordPage";
import ResetPasswordPage from "./Pages/Login/ResetPasswordPage";
import PublicEventRegistration from "./Pages/SpecialEvents/PublicEventRegistration";
import withAppProviders from "./withAppProviders";
import { VendorAuthProvider } from "./Pages/VendorPortal/VendorAuthContext";
import VendorRoutes from "./Pages/VendorPortal/VendorRoutes";

const App: React.FC = () => {
  return (
    <Box data-testid="pos-ui-app">
      <MainLayout>
        <BrowserRouter basename={BASENAME}>
          <Routes>
            {/* Vendor Portal — separate route tree, own layout + auth */}
            <Route
              path="/vendor/*"
              element={
                <VendorAuthProvider>
                  <VendorRoutes />
                </VendorAuthProvider>
              }
            />

            {/* Public auth-recovery routes — MUST sit above the
                LoginProvider gate. Users hitting these from an SMS/email
                link have no session yet, so they cannot pass through the
                Sanctum-protected branch below. */}
            <Route path="/forgot-password" element={<ForgotPasswordPage />} />
            <Route path="/reset-password"  element={<ResetPasswordPage />} />

            {/* Public guest event registration — opened from a QR code on
                marketing materials. Sits above LoginProvider for the same
                reason: zero auth, no token required.

                The /registerevent/:slug path is the legacy URL kept alive
                so any QR codes already in the wild don't dead-link. New
                shares use the shorter /reg/:slug path. */}
            <Route path="/reg/:slug"           element={<PublicEventRegistration />} />
            <Route path="/registerevent/:slug" element={<PublicEventRegistration />} />

            {/* Main admin app — everything else */}
            <Route
              path="/*"
              element={
                <LoginProvider>
                  <Box>
                    <MiniDrawer>
                      <AppRoutes />
                    </MiniDrawer>
                  </Box>
                </LoginProvider>
              }
            />
          </Routes>
        </BrowserRouter>
      </MainLayout>
    </Box>
  );
};

export default withAppProviders(App);
